import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { baseUrl } from '../../../enum/constant';

const base = baseUrl;
const BASE_URL = base + "api/bank-info";

const UserView = ({ userId }) => {
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        setLoading(true);

        const response = await axios.get(`${BASE_URL}/showDetail/${userId}`);
        setError('');
        setUserDetails(response.data);
      } catch (err) {
        setError('not submitted bank details yet');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchUserDetails();
    }
  }, [userId]);

  if (loading) {
    return <div className="mt-md-5 pt-md-5"><div className="mt-md-5"><p>Loading...</p></div></div>;
  }

  if (error) {
    return <div className="mt-md-5 pt-md-5"><div className="mt-md-5"><p>{error}</p></div></div>;
  }

  if (!userDetails) {
    return <div className="mt-md-5 pt-md-5"><div className="mt-md-5"><p>No user details found.</p></div></div>;
  }

  return (
    <div className="cus-dash-container container">
      <h4>Bank Details</h4>
      <div className="bnk-detail mt-3" style={{ overflowX: "auto" }}>
        <table className="table table-sm">
          <tbody>
            <tr>
              <td><strong>Email :</strong></td>
              <td>{userDetails.email}</td>
              <td><strong>Create at :</strong></td>
              <td>{new Date(userDetails.created_at).toISOString().split('T')[0]}</td>
            </tr>
            <tr>
              <td><strong>Bank Name:</strong></td>
              <td>{userDetails.bank_name}</td>
              <td><strong>BIC/Swift:</strong></td>
              <td>{userDetails.bic_swift}</td>
            </tr>
            <tr>
              <td><strong>Reference Field:</strong></td>
              <td>{userDetails.reference_field}</td>
              <td><strong>Supported Payments:</strong></td>
              <td>{userDetails.supported_payments}</td>
            </tr>
            <tr>
              <td><strong>Bank Address:</strong></td>
              <td>{userDetails.bank_address}</td>
              <td><strong>Company Name:</strong></td>
              <td>{userDetails.company_name}</td>
            </tr>
            <tr>
              <td><strong>Company Address:</strong></td>
              <td>{userDetails.company_address}</td>
              <td><strong>Account Number:</strong></td>
              <td>{userDetails.account_number}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserView;
